<template>
  <section class="section" id="app">
    <router-view/>
  </section>
</template>
<script lang="js" type="text/babel">
    export default {
        name: 'app'
    }
</script>
<style lang="css" type="text/css">
  @import '~bulma/css/bulma.css';
</style>
<style lang="css" scoped type="text/css">
  #app {
  }
</style>
